import type { ApiEvent } from '@api/events';

export interface SpineCancellationTarget {
  identifier: string;
  adminUrl: string | null;
}

// The linked Spine orders still needing manual cancellation. Already cancelled
// in Spine is dropped; deleted from Spine has no admin_url and renders unlinked.
export function spineCancellationTargets(events: ApiEvent[]): SpineCancellationTarget[] {
  return events.flatMap((event) => {
    const spineOrder = event.spine_order;
    if (!spineOrder || spineOrder.state === 'cancelled') return [];

    return [{identifier: spineOrder.identifier, adminUrl: spineOrder.admin_url ?? null}];
  });
}
